export default "__VITE_ASSET__Dux2kW9a__"